"use client";

// packages/eden-appearance/src/components/AppearanceSection.jsx
import { useState, useEffect, useRef, useContext, forwardRef } from "react";
import styled, { ThemeProvider } from "styled-components";
import { AppearanceContext } from './AppearanceContext.js';
import { getAllModeStyles } from './modes.js';
import { jsx } from "react/jsx-runtime";
var AppearanceRoot = styled.div`
  ${({ $mode, $parentMode, $forceOutput }) => {
  if ($mode === $parentMode && !$forceOutput) return;
  const lightStyles = getAllModeStyles("light");
  const darkStyles = getAllModeStyles("dark");
  if ($mode === "light") {
    return `
        color-scheme: light;
        ${lightStyles}
      `;
  } else if ($mode === "dark") {
    return `
        color-scheme: dark;
        ${darkStyles}
      `;
  } else {
    return `
        color-scheme: light dark;
        ${lightStyles}
        @media(prefers-color-scheme: dark) { ${darkStyles} }
      `;
  }
}}
  /* Using hardcoded variable names due to a race condition of this needing to use names/values that may not be available yet. */
  background: var(--background-color-level-current, #ffffff);
  color: var(--text-color-primary, #212225);
`;
var AppearanceSectionComponent = ({ children, mode = "os", renderAs, ...props }, ref) => {
  const appearanceContext = useContext(AppearanceContext);
  const [contextValue, setContextValue] = useState({ mode });
  const firstRender = useRef(true);
  useEffect(() => {
    if (firstRender.current === true) {
      firstRender.current = false;
    } else {
      setContextValue({ mode });
    }
  }, [mode]);
  return /* @__PURE__ */ jsx(AppearanceContext.Provider, { value: contextValue, children: /* @__PURE__ */ jsx(ThemeProvider, { theme: { edenAppearanceMode: contextValue.mode }, children: /* @__PURE__ */ jsx(
    AppearanceRoot,
    {
      $mode: mode,
      $parentMode: appearanceContext?.mode,
      $forceOutput: props.forceOutput,
      as: renderAs,
      ...props,
      ref,
      children
    }
  ) }) });
};
var AppearanceSection = forwardRef(AppearanceSectionComponent);
AppearanceSection.displayName = "AppearanceSection";
var AppearanceSection_default = AppearanceSection;
export {
  AppearanceSection_default as default
};
